export default "__VITE_ASSET__$ee1XzTd__"